import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";

export default function GoogleCallback() {
  const { loginWithGoogleSession } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [error, setError] = useState(null);

  useEffect(() => {
    let sessionId = null;
    if (window.location.hash) {
      const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
      sessionId = params.get("session_id");
    }
    if (!sessionId) {
      const params = new URLSearchParams(window.location.search);
      sessionId = params.get("session_id");
    }

    if (!sessionId) {
      setError("Missing session_id from authentication provider.");
      setTimeout(() => navigate("/login"), 2500);
      return;
    }

    loginWithGoogleSession(sessionId)
      .then(() => {
        toast.success(t("login.submit") + " ✓");
        navigate("/dashboard", { replace: true });
      })
      .catch((err) => {
        const detail = err.response?.data?.detail;
        if (err.response?.status === 403) {
          setError(typeof detail === "string" ? detail : t("login.checkEmail"));
        } else {
          setError(typeof detail === "string" ? detail : t("login.genericError"));
        }
        setTimeout(() => navigate("/login"), 3500);
      });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F8FA] text-[#0A1F44]" data-testid="google-callback-page">
      <div className="bg-white rounded-2xl border border-slate-200 p-8 max-w-md text-center shadow-sm">
        {error ? (
          <>
            <p className="text-[#C8102E] font-medium">{error}</p>
            <p className="text-sm text-slate-500 mt-3">Redirecting…</p>
          </>
        ) : (
          <p>{t("common.loading")}</p>
        )}
      </div>
    </div>
  );
}
